export default __webpack_public_path__ + "static/media/basic-push-pin-3.53684cd6.png";